import UserCenter from './userCenter' //用户中心

//用户
export default [
    {
        path: 'user',
        name: 'user',
        meta: {
            title: '用户',
            icon: 'user'
        },
        hidden: false,
        component: () => import("@/views/user/index.vue"),
        children:[
            ...UserCenter
        ]
    }

]